module.exports = __webpack_public_path__ + "img/Natalia.61d2b7d2.jpg";